import { FC, ReactNode } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DialogClasses } from "@mui/material/Dialog";
import { FormattedMessage } from "react-intl";
import { onCloseExcept } from "../../utils/dialogUtils";

export enum ButtonAction {
    SAVE = "save",
    CANCEL = "cancel",
}

interface FormDialogProps {
    id: string;
    open: boolean;
    onClose: (action: ButtonAction) => void;
    showTitle?: boolean;
    title?: ReactNode;
    showCancelBtn?: boolean;
    cancelBtnNode?: ReactNode;
    saveBtnNode?: ReactNode;
    classes?: Partial<DialogClasses>;
    disableEscapeKeyDown?: boolean;
    fullScreen?: boolean;
    fullWidth?: boolean;
    maxWidth?: any;
    scroll?: "body" | "paper";
    sx?: any;
    children?: ReactNode;
}

const FormDialog: FC<FormDialogProps> = (props) => {
    const {
        id,
        open,
        onClose,
        showTitle,
        title,
        showCancelBtn,
        cancelBtnNode,
        saveBtnNode,
        children,
        classes,
        disableEscapeKeyDown,
        fullScreen,
        fullWidth,
        maxWidth,
        scroll,
        sx,
    } = props;

    const handleSave = () => {
        onClose(ButtonAction.SAVE);
    };

    const handleCancel = () => {
        onClose(ButtonAction.CANCEL);
    };

    return (
        <Dialog
            open={open}
            aria-describedby={id}
            classes={classes}
            fullScreen={fullScreen}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            scroll={scroll}
            sx={sx}
            onClose={onCloseExcept(disableEscapeKeyDown ? ["escapeKeyDown"] : [], handleCancel)}
        >
            {showTitle && title ? <DialogTitle>{title}</DialogTitle> : null}
            <DialogContent dividers>{children}</DialogContent>
            <DialogActions>
                {showCancelBtn
                    ? cancelBtnNode || (
                          <Button onClick={handleCancel}>
                              <FormattedMessage id="common.button-label.cancel" defaultMessage="Cancel" />
                          </Button>
                      )
                    : null}
                {saveBtnNode || (
                    <Button onClick={handleSave}>
                        <FormattedMessage id="common.button-label.save" defaultMessage="Save" />
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default FormDialog;
